






































































































import axios from 'axios';
import EventBus from '@/eventBus';

export default {
    name: 'ChangePlanMembership',

    props: ['plan', 'selected'],
    data() {
        return {
            coupon: null,
            couponID: '',
        };
    },
    computed: {},
    methods: {
        totalPrice() {
            let total = this.calculatePrice(this.plan);
            if (this.selected) {
                this.selected.forEach((element) => {
                    total += this.calculatePrice(element);
                });
            }

            if (this.coupon) {
                if (this.coupon.AmountOff > 0) {
                    total -= this.coupon.AmountOff / 100;
                } else if (this.coupon.PercentageOff != 0.0) {
                    total *= 1 - this.coupon.PercentageOff / 100;
                }

                if (total < 0) {
                    total = 0;
                }
            }
            return total.toFixed(2);
        },

        calculatePrice(item) {
            if (!item || !item.PriceInCents) return 0;

            let price = item.PriceInCents / 100.0;

            if (!item.TaxRate || (item.TaxRate && item.TaxRate.Inclusive)) return price;

            if (item.TaxRate && item.TaxRate.Percentage) {
                price = price * (item.TaxRate.Percentage / 100 + 1);
            }
            return price;
        },
        applyCoupon() {
            axios
                .get(`/space/coupon/${this.couponID}`)
                .then((res) => {
                    this.coupon = res.data;

                    this.$store.commit('SET_COUPON', {
                        Coupon: this.coupon.ID,
                    });
                    this.totalPrice();
                    this.$emit('couponApplied', this.coupon);
                })
                .catch((err) => {
                    this.coupon = null;
                    EventBus.$emit('ERROR', {
                        Message: 'Coupon code is invalid',
                    });
                    console.log(err);
                });
        },
        updateCoupon() {
            if (!this.couponID) {
                this.coupon = null;
                this.$store.commit('SET_COUPON', {
                    Coupon: '',
                });
                this.totalPrice();
            }
        },

        removeCoupon() {
            this.coupon = null;
            this.couponID = '';
            this.$store.commit('SET_COUPON', {
                Coupon: '',
            });
            this.$emit('couponApplied', this.coupon);
            this.totalPrice();
        },
    },
};
